<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { onMount, setContext } from 'svelte';
	import { writable } from 'svelte/store';
	//Serivces
	import { format } from 'svelte-i18n';
	//SPa methods
	import { replace } from 'svelte-spa-router';
	//Stores
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices } from 'src/stores/lists/devices';
	import { app, network } from 'src/stores/session/native-bridge';
	import { device_object } from 'src/stores/wizards';
	import { addDeviceModal, pending_connection_devices } from 'src/stores/device-runtime/firmware-ui';
	//Helpers
	import {
		resetWizardItems,
		setWizardSteps,
		updateWizardStepOnPrevNext,
		updateWizardStepOnWizardItem,
		requestAddDevice,
		scrollToElement,
		scrollToElementInConditionalStep,
	} from 'src/components/Lists/list-helpers';
	import { capFirstChar, wait } from 'src/helpers/utilities';
	import { getDevicesStateByID } from 'src/services/iotu/v2_device_state';
	//Design system helpers
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	//Design system components
	import {
		Modal,
		Wizard,
		WizardItem,
		WizardContainer,
		WizardContent,
		Container,
		Button,
		Alert,
		EngagingLoader,
		toast,
		Select,
		Text,
	} from '@Shelly/shelly-design-system';
	//Components
	import MainStep from './AddEditSteps/MainStep.svelte';
	import SelectRoomStep from './AddEditSteps/SelectRoomStep.svelte';
	import SelectGatewaysStep from './AddEditSteps/SelectGatewaysStep.svelte';
	import { getStatus } from 'src/helpers/get_status_settings_helpers';

	// Create temporary store that will go trough context

	import { enable_cloud } from 'src/services/local_requests';
	import type { AddDeviceResponse } from 'src/types/responses/Device';
	import { mobile } from 'src/services/mobile-rework';
	import { shendure } from 'src/services/http';
	import ExitConfirmationInclusionModal from 'src/components/BleWebInclusion/ExitConfirmationInclusionModal.svelte';
	import { is_loqed, isCoverWithDeviceProfile, isDistance } from 'src/helpers/interface_helpers';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { checkMode } from 'src/helpers/mode_switch_helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { updateDeviceDistanceSettings } from 'src/helpers/distance_helper';

	// import { createEventDispatcher } from 'svelte';
	// const dispatch = createEventDispatcher();

	let createNewRoomStore: SvelteStore<any> = writable({
		newRoom: undefined,
		newRoomEditing: false,
	});

	setContext('newRoomStore', createNewRoomStore);
	//Encapsulating createNewRoomStore into context in AssociateWizard and EditDeviceWizard so after the wizards are destroyed, the stores will be destroyed and unsubscribe from them.
	//the tricky part here is how we update the store
	//we have to  update the store like so:
	//$createNewRoomStore = {
	// 	newRoom: newRoomVar,
	// 	newRoomEditing: booleanVar
	// }

	// end of temporary store

	let editDevice = $device_object;

	const enableCloudAfterAccountAssociation = editDevice.enableCloudAfterAccountAssociation;
	delete editDevice.enableCloudAfterAccountAssociation;

	const previousButton = $format('button_back');

	let modalRef: Modal = null;
	let wizardItemsContainerRef: HTMLElement = null;
	let selectedRef: HTMLElement = null;
	let scrolledToView = false;
	let requestGatewayLoader = false;
	let SelectGatewaysStepComponent;

	let requestLoader = false;
	let isSuccessful = false;
	let progress = 0;

	let isNewRoomCreated = false;
	let updateFullHeight: boolean = false;
	let newRoomEditing;
	let showConfirmation = false;

	let isLastStepWizard;
	let disablePrevBtn = false;
	let disableNextBtn = false;
	let value = 'switch';
	let loading = false;
	let cache = value;
	const i18n_options = {
		switch: $format('label_switch', { default: 'switch' }),
		cover: $format('label_cover', { default: 'cover' }),
	};

	$: ({ newRoomEditing } = $createNewRoomStore);

	let wizardSteps = [
		$format('details_step', { default: 'Details' }),
		$format('select_room_step', { default: 'select room' }),
	];

	if (editDevice.gen == 'GBLE') {
		wizardSteps.splice(1, 0, $format('select_gateways_step', { default: 'select gateways' }));
	}

	if (isCoverWithDeviceProfile(editDevice.type)) {
		wizardSteps.push(
			capFirstChar(
				$format('select_type', {
					values: {
						type: $format('label_mode', { default: 'mode' }).toLowerCase(),
					},
					default: 'Select mode',
				}),
			),
		);
	}

	let wizardItems = setWizardSteps(wizardSteps);

	let activeWizardStep = wizardItems[0];

	$: isLastStepWizard = activeWizardStep.activeIndex === wizardItems.length - 1;

	$: nextButton = isLastStepWizard ? $format('button_save') : $format('button_next');
	// reset scrolled to view variable after step change
	$: (activeWizardStep.activeIndex, (scrolledToView = false));
	$: isGbleDevice = editDevice.gen === 'GBLE';

	const onCloseAddModal = () => {
		addDeviceModal.set(false);
		wizardItems = resetWizardItems(wizardItems);
		activeWizardStep = wizardItems[0];
		isNewRoomCreated = false;
		updateFullHeight = undefined;
		$createNewRoomStore = {
			newRoom: undefined,
			newRoomEditing: false,
		};
		// ss_rm && DSK
	};

	$: (isNewRoomCreated, scrollToElementInConditionalStep(selectedRef, isNewRoomCreated));

	// let disabled;

	let gatewayDisableNext = false;

	// reset scrolled to view varia

	$: disabledConditions =
		editDevice.gen == 'GBLE'
			? [
					$network === 'offline' ||
						!editDevice.name ||
						editDevice?.name?.trim() === '' ||
						(!editDevice.image && !editDevice.backgroundColor && !editDevice.icon),

					requestGatewayLoader || (activeWizardStep.activeIndex === 1 && gatewayDisableNext),

					$network === 'offline' ||
						requestLoader ||
						!editDevice.room_id ||
						!editDevice.name ||
						editDevice.name == '' ||
						(!editDevice.image && !editDevice.backgroundColor && !editDevice.icon),

					requestLoader,
				]
			: [
					$network === 'offline' ||
						!editDevice.name ||
						editDevice?.name?.trim() === '' ||
						(!editDevice.image && !editDevice.backgroundColor && !editDevice.icon),
					$network === 'offline' ||
						requestLoader ||
						!editDevice.room_id ||
						!editDevice.name ||
						editDevice.name == '' ||
						(!editDevice.image && !editDevice.backgroundColor && !editDevice.icon),
				];

	//#region Wizard Functions
	const onClickWizardItem = (index: number, finished?: boolean) => {
		if (isCoverWithDeviceProfile(editDevice.type) && index == 2 && !finished) {
			onFinish();
			return;
		}

		// handle "Gatways step" call on Steps navigation Click
		if (editDevice.gen == 'GBLE' && index == 2 && activeWizardStep.activeIndex == 1) {
			SelectGatewaysStepComponent.updateGatewaysList();
		}
		const result = updateWizardStepOnWizardItem(index, wizardItems, activeWizardStep);
		wizardItems = result.wizardItems;
		activeWizardStep = { ...result.activeWizardStep };

		scrollSelectedCardToView();
	};

	const onClickPrevNextButton = (type: 'prev' | 'next') => {
		// handle "Gatways Step" call on Steps navigation Next
		if (editDevice.gen == 'GBLE' && type == 'next' && activeWizardStep.activeIndex == 1) {
			SelectGatewaysStepComponent.updateGatewaysList();
		}
		const result = updateWizardStepOnPrevNext(type, wizardItems, activeWizardStep);

		wizardItems = result.wizardItems;
		activeWizardStep = { ...result.activeWizardStep };

		scrollSelectedCardToView();
	};

	const onFinish = async () => {
		requestLoader = true;

		setInterval(() => {
			progress = progress + 5;
		}, 100);
		editDevice.name = editDevice.name.trim();

		const addRes: AddDeviceResponse = await requestAddDevice(editDevice);

		// open modal for device key, currently used for wall display

		if (addRes.isok) {
			if (enableCloudAfterAccountAssociation) {
				await enable_cloud(editDevice, editDevice.ip);
			}

			isSuccessful = true;
			progress = 100;

			await wait(2000);

			requestLoader = false;
			disablePrevBtn = true;
			disableNextBtn = false;
			// add the id to the pending commands list if it is not present yet
			if (
				typeof $devices[editDevice.id] !== 'undefined' ||
				$pending_connection_devices.indexOf(editDevice.id) < 0
			) {
				console.log(`add ${editDevice.id} to pending_connection_devices`);
				pending_connection_devices.add(editDevice.id);
			}
			// use this if you want to open TemplatesModal from inclusion process
			//dispatch('finished', { device: editDevice });

			if (isCoverWithDeviceProfile(editDevice.type)) {
				if (activeWizardStep.activeIndex === 0) {
					onClickWizardItem(2, true);
				} else {
					onClickPrevNextButton('next');
				}
			} else {
				replace(`/home/room/${editDevice.room_id}/devices`);
				onCloseAddModal();
			}

			if (isGbleDevice) {
				await wait(3000);
				getStatus(editDevice);
				devices_settings.update_devices_settings(editDevice.id, {
					device: {
						sleep_mode: true,
					},
					sleep_mode: {
						period: 86400,
						unit: 's',
					},
					_pending_cmds: 0,
				});
				if (isDistance(editDevice.type)) await updateDeviceDistanceSettings(editDevice);
			}

			if (editDevice.gen === 'GXP') {
				try {
					let res = await shendure.get(`add_device?device_id=${editDevice.id}`);
					if (res?.data?.isok) {
						console.log('Registered zendure device');
					}
				} catch (erorr) {
					toast.open({
						type: 'danger',
						title: $format('failed_to_add', {
							default: 'Failed to add the device, please try again.',
						}),
					});
				}
			}

			if (is_loqed(editDevice)) {
				await getDevicesStateByID(editDevice.id);
			}
		} else {
			requestLoader = false;
			disableNextBtn = true;
			disablePrevBtn = false;
			if (addRes.data.errors[editDevice?.id].code == 2) {
				toast.open({
					type: 'danger',
					title: $format('cloud_connect_owned_err_toast', {
						default: 'The device is already owned by another user\/account.',
					}),
				});
			} else {
				toast.open({
					type: 'danger',
					title: $format('failed_to_add', {
						default: 'Failed to add the device, please try again.',
					}),
				});
			}
		}
	};
	//#endregion Wizard Functions

	let removeContainerEventListener = () => {};

	//#region Wizard Scroll to Functions
	const scrollSelectedCardToView = () => {
		removeContainerEventListener();

		let elementRef = null;
		let wizardStepIndex = 0;

		if (activeWizardStep.activeIndex === 1 && selectedRef && !scrolledToView) {
			elementRef = selectedRef;
			wizardStepIndex = 1;
		}

		if (!elementRef) {
			// Scroll to top, when no card is selected
			modalRef.scrollToTop();
		} else {
			removeContainerEventListener = scrollToElement(
				elementRef,
				wizardItemsContainerRef,
				activeWizardStep.activeIndex,
				wizardStepIndex,
			);
		}

		scrolledToView = true;
	};
	//#endregion Wizard Scroll to Functions

	const successImageSrc = './images/engagingLoader/circle-check-thin.svg';

	const imagesSrc = [
		'./images/engagingLoader/blu-button1-device.svg',
		'./images/engagingLoader/ht-gen3.svg',
		'./images/engagingLoader/blu-motion-device.svg',
		'./images/engagingLoader/1pm-mini-gen3.svg',
		'./images/engagingLoader/shelly-plus-1.svg',
	];

	const closeModal = (e: CustomEvent) => {
		if ($addDeviceModal) {
			e.preventDefault();
			addDeviceModal.set(false);
		}
	};

	onMount(() => {
		if (mobile.isMobile) {
			mobile.addEventListener('back_button', closeModal);
			return () => mobile.removeEventListener('back_button', closeModal);
		}
	});

	const selectMode = (e) => {
		for (const key in i18n_options) {
			if (i18n_options[key] === e.detail) {
				value = key;
			}
		}
	};

	const onChangeDeviceProfile = async () => {
		if (cache === value) {
			replace(`/home/room/${editDevice.room_id}/devices`);
			onCloseAddModal();
		}

		loading = true;
		const id = editDevice.id;
		const settings = { ...readDeviceSettings(id) };
		const params = {
			id: 0,
			name: value,
		};
		const res: SettingRequest = await gen2Request($devices[id], 'Shelly.SetProfile', params);
		const response = onSettingsResponse(res, $devices[id]);
		if (response?.isok) {
			settings.sys.device.profile = value; //updating settings before checking mode
			cache = value;
		} else {
			value = cache;
		}
		await checkMode(id, settings); //checking mode with new settings
		replace(`/home/room/${editDevice.room_id}/devices`);
		onCloseAddModal();
		loading = false;
	};
</script>

<Modal
	on:close={() => {
		showConfirmation = true;
	}}
	showModal={$addDeviceModal}
	title={capFirstChar($format('label_menu_items_device', { default: 'Add device' }))}
	bind:this={modalRef}
	hideSlotFooter={newRoomEditing}
	removeScrollPadding
>
	<Wizard slot="toolbar">
		{#each wizardItems as item, i (i)}
			<WizardItem
				on:click={() => {
					onClickWizardItem(i);
				}}
				active={item.active}
				title={capFirstChar(item.title)}
				disabled={disabledConditions[i - 1] ||
					(newRoomEditing && !item.active) ||
					(editDevice.gen == 'GBLE' && i === 2 && gatewayDisableNext) ||
					(isCoverWithDeviceProfile(editDevice.type) &&
						((requestLoader &&
							((activeWizardStep.activeIndex === 0 && (i === 1 || i === 2)) ||
								(activeWizardStep.activeIndex === 1 && (i === 0 || i === 2)))) ||
							((i === 0 || i === 1) && disablePrevBtn) ||
							(i === 2 && disableNextBtn)))}
				showMoreDots={item.showMoreDots}
				indicatorColor={$showNewLayout ? 'color-2' : undefined}
			/>
		{/each}
	</Wizard>

	<div class:flex-overflow-hidden={newRoomEditing} slot="content">
		<WizardContainer
			activeStepIndex={activeWizardStep.activeIndex}
			adaptiveHeight
			bind:wizardItemsContainerRef
			fullHeight={updateFullHeight}
		>
			{#if $network === 'offline'}
				<Container padding="scrollPaddings">
					<Alert
						type="danger"
						heading={$format('alert_heading_associate_offline', {
							default: 'You are offline!',
						})}
						message={$format('alert_message_associate_offline', {
							default:
								'To continue associating the device with your account, please connect to the internet. Either via a Wi-Fi network or mobile data.',
						})}
					/>
				</Container>
			{:else}
				{#each wizardItems as _, i (i)}
					<!-- DO NOT REMOVE COMMENT: Padding references -->
					<WizardContent
						active={activeWizardStep.activeIndex === i}
						class={classMap({
							'pb-s': i === 0 || (i === 1 && !isGbleDevice) || i > 1,
							'pt-s': i === 0 || (i === 1 && !isGbleDevice) || i > 1,
							'pl-0 pr-0': i == 1 && isGbleDevice,
						})}
					>
						{#if i === 0}
							<MainStep
								bind:editDevice
								focusOnLoad={!$app}
								on:enter={() => onClickPrevNextButton('next')}
							/>
						{:else if i == 1 && isGbleDevice}
							<SelectGatewaysStep
								bind:requestGatewayLoader
								bind:this={SelectGatewaysStepComponent}
								associatedDevice={editDevice}
								bind:gatewayDisableNext
							/>
							<!-- DO NOT REMOVE COMMENT: Padding references -->
							<div class="pb-s" />
						{:else if requestLoader && !isCoverWithDeviceProfile(editDevice.type)}
							<Container padding="0">
								<div class="d-flex justify-content-center">
									<EngagingLoader
										show
										title={capFirstChar(
											isSuccessful
												? $format('associate_device_state_completed', {
														values: { deviceName: editDevice.name },
														default: `congratulations, ${editDevice.name} is now a part of your account.`,
													})
												: $format('associate_device_state_default', {
														default: 'associating, device with your account',
													}),
										)}
										{progress}
										type="content"
										{isSuccessful}
										{imagesSrc}
										{successImageSrc}
										errorImageSrc=""
									>
										<!-- <Text slot="description">
											{$format('text_associate_loader_description', {
												default: 'Final setup. We are nearly done!'
											})}
										</Text> -->
									</EngagingLoader>
								</div>
							</Container>
						{:else if isCoverWithDeviceProfile(editDevice.type)}
							{#if i == 1}
								<SelectRoomStep
									bind:editDevice
									bind:selectedRef
									bind:updateFullHeight
									on:after-room-update={() => {
										isNewRoomCreated = true;
									}}
									{requestLoader}
								/>
							{:else}
								<Alert
									class="mb-m"
									type="warning"
									heading={$format('alert_warning_heading_cover_profile', {
										default:
											'If a motor is connected to the device, it must be switched to cover mode to prevent potential damage.',
									})}
								/>
								<Text element="h2" class="mb-s">
									{$format('subtitle_select_device_profile', {
										default: 'Select Device Profile',
									})}
								</Text>
								<Select
									size="m"
									value={i18n_options[value]}
									options={Object.values(i18n_options)}
									icon={'fas fa-info-circle'}
									info={$format('text_modal_remove_device_from_group_description', {
										default:
											'Warning: Changing device profile would restart the device and clear all existing schedules and actions.',
									})}
									on:change={(e) => selectMode(e)}
									id="select-n588m54"
									aria-label={$format('device_profile', { default: 'Device profile' })}
								/>
							{/if}
						{:else}
							<SelectRoomStep
								bind:editDevice
								bind:selectedRef
								bind:updateFullHeight
								on:after-room-update={() => {
									isNewRoomCreated = true;
								}}
								{requestLoader}
							/>
						{/if}
					</WizardContent>
				{/each}
			{/if}
		</WizardContainer>
	</div>

	<svelte:fragment slot="footer">
		{#if activeWizardStep.activeIndex === 1 && editDevice.gen == 'GBLE' && gatewayDisableNext}
			<Alert
				class="mb-s"
				heading={capFirstChar(
					$format('alert_header_danger_no_gateway_selection', {
						default: 'Please select at least one gateway.',
					}),
				)}
				isHeadingBold
				type={'danger'}
			/>
		{/if}
		<div class="d-flex justify-content-end">
			{#if activeWizardStep.activeIndex > 0}
				<Button
					class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
					icon={undefined}
					variant="secondary"
					responsiveSize={{
						sm: 'm',
					}}
					loading={requestLoader}
					disabled={requestLoader ||
						requestGatewayLoader ||
						(isCoverWithDeviceProfile(editDevice.type) && (requestLoader || disablePrevBtn))}
					on:click={() => onClickPrevNextButton('prev')}
				>
					{previousButton}
				</Button>
			{/if}
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
				icon={isLastStepWizard ? 'fas fa-save' : ''}
				rightIcon={isLastStepWizard ? '' : 'fas fa-chevron-right'}
				responsiveSize={{
					sm: 'm',
				}}
				loading={requestLoader || loading}
				disabled={disabledConditions[activeWizardStep.activeIndex] ||
					(isCoverWithDeviceProfile(editDevice.type) &&
						(requestLoader || loading || disableNextBtn))}
				on:click={() => {
					if (isCoverWithDeviceProfile(editDevice.type)) {
						if (isLastStepWizard) {
							onChangeDeviceProfile();
						} else if (activeWizardStep.activeIndex === 1) {
							onFinish();
						} else {
							onClickPrevNextButton('next');
						}
						return;
					}

					if (isLastStepWizard) {
						onFinish();
					} else {
						onClickPrevNextButton('next');
					}
				}}
			>
				{nextButton}
			</Button>
		</div>
	</svelte:fragment>
</Modal>

<ExitConfirmationInclusionModal bind:showModal={showConfirmation} on:confirm={onCloseAddModal} />
